import { SaveButton } from "components/Buttons"
import {
  CheckboxField,
  RadioField,
  RichTextField,
  SingleSelectField,
  TextField,
} from "components/RenderInput"
import React, { useEffect, useState } from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import {
  change,
  Field,
  FormSection,
  formValueSelector,
  initialize,
} from "redux-form"
import { FORM_NAMES } from "constants/index"
import { connect } from "react-redux"
import {
  addEventInfo,
  getEventInfo,
  resetEventInfo,
  updateEventInfo,
} from "store/actions"
import LocationAutocomplete from "./locationAutocomplete"
import Preview from "./preview"
import { getCurrentDate } from "utils"

const EventInfoTab = props => {
  return (
    <Card>
      <CardBody>
        <Row className="mb-3">
          <Col>
            <h3>{props.feature.label}</h3>
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Save"
              onClick={props.saveHandler}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <CardHeader>
                <h4>ADD INFORMATION</h4>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <Field name="name" component={TextField} label="Name" />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col>
                    <label>Start date</label>
                  </Col>
                </Row>
                <Row>
                  <Col xs="auto" className="my-1">
                    <Field
                      name="startDate"
                      component={TextField}
                      type="date"
                      min={getCurrentDate()}
                    />
                  </Col>
                  <Col xs="auto" className="my-1">
                    <Field
                      name="startHour"
                      component={TextField}
                      type="number"
                      min="1"
                      max="12"
                      placeholder="HH"
                    />
                  </Col>
                  <Col xs="auto" className="my-1">
                    <Field
                      name="startMinute"
                      component={TextField}
                      type="number"
                      min="0"
                      max="59"
                      placeholder="MM"
                    />
                  </Col>
                  <Col xs="auto" style={{ minWidth: "120px" }} className="my-1">
                    <Field
                      name="startTimeType"
                      component={SingleSelectField}
                      placeholder="AM/PM"
                      options={[
                        {
                          options: [
                            { label: "AM", value: "AM" },
                            { label: "PM", value: "PM" },
                          ],
                        },
                      ]}
                      isSearchable={false}
                    />
                  </Col>
                  <Col xs="auto">
                    <i
                      className="bx bx-sm bx-x"
                      style={{
                        cursor: "pointer",
                        paddingTop: "7px",
                        color: "#34c38f",
                      }}
                      onClick={() => {
                        props.changeField("event_info_form.startDate", null)
                        props.changeField("event_info_form.startHour", null)
                        props.changeField("event_info_form.startMinute", null)
                        props.changeField("event_info_form.startTimeType", null)
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col>
                    <label>End date</label>
                  </Col>
                </Row>
                <Row>
                  <Col xs="auto" className="my-1">
                    <Field
                      name="endDate"
                      component={TextField}
                      type="date"
                      min={props.startDate || getCurrentDate()}
                    />
                  </Col>
                  <Col xs="auto" className="my-1">
                    <Field
                      name="endHour"
                      component={TextField}
                      type="number"
                      min="1"
                      max="12"
                      placeholder="HH"
                    />
                  </Col>
                  <Col xs="auto" className="my-1">
                    <Field
                      name="endMinute"
                      component={TextField}
                      type="number"
                      min="0"
                      max="59"
                      placeholder="MM"
                    />
                  </Col>
                  <Col xs="auto" style={{ minWidth: "120px" }} className="my-1">
                    <Field
                      name="endTimeType"
                      component={SingleSelectField}
                      placeholder="AM/PM"
                      options={[
                        {
                          options: [
                            { label: "AM", value: "AM" },
                            { label: "PM", value: "PM" },
                          ],
                        },
                      ]}
                      isSearchable={false}
                    />
                  </Col>
                  <Col xs="auto" className="my-1">
                    <i
                      className="bx bx-sm bx-x"
                      style={{
                        cursor: "pointer",
                        paddingTop: "7px",
                        color: "#34c38f",
                      }}
                      onClick={() => {
                        props.changeField("event_info_form.endDate", null)
                        props.changeField("event_info_form.endHour", null)
                        props.changeField("event_info_form.endMinute", null)
                        props.changeField("event_info_form.endTimeType", null)
                      }}
                    />
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <Field
                      name="locationName"
                      component={TextField}
                      label="Location Name"
                    />
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col xs={12}>
                    <label>Address</label>
                  </Col>
                  <Col>
                    <Field
                      name="address.address"
                      component={LocationAutocomplete}
                    />
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <Field
                      name="meetingLink"
                      component={TextField}
                      label="Meeting Link"
                    />
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col xs={12}>
                    <label>Extra Details</label>
                  </Col>
                  <Col>
                    <Field name="extraDetails" component={RichTextField} />
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card>
              <CardHeader>
                <h4>SET RSVP OPTION</h4>
              </CardHeader>
              <CardBody>
                <Row className="mb-3">
                  <Col xs={12} className="mt-2">
                    <Field
                      name="rsvpOption"
                      type="radio"
                      component={RadioField}
                      value="0"
                      label="Do not display the RSVP options"
                    />
                  </Col>
                  <Col xs={12} className="my-2">
                    <Field
                      name="rsvpOption"
                      type="radio"
                      component={RadioField}
                      value="1"
                      label="Display the RSVP options"
                    />
                  </Col>
                </Row>
                {props.rsvpOption === "1" && (
                  <>
                    <Row className="my-3">
                      <Col xl={12}>
                        How many spots are available for this event? (Optional)
                      </Col>
                      <Col xl={5} className="mt-1">
                        <Field
                          name="rsvpLimit"
                          component={TextField}
                          type="number"
                          placeholder="Available spots"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3">
                      <Col>
                        <span>
                          {props?.rsvpBookedSpots?.booked_spots_number} spot(s)
                          already booked
                        </span>
                      </Col>
                    </Row>
                    <Row className="my-3">
                      <Col xl={12}>Max spots allowed per RSVP?</Col>
                      <Col xl={5} className="mt-1">
                        <Field
                          name="maxRsvp"
                          component={TextField}
                          type="number"
                          placeholder="Max spots allowed per RSVP"
                        />
                      </Col>
                    </Row>
                    <Row className="my-3">
                      <Col>
                        <Field
                          name="maybeOption"
                          component={CheckboxField}
                          label="Add Maybe Option"
                        />
                      </Col>
                    </Row>
                    {props.maybeOption && (
                      <Row className="my-3">
                        <Col>
                          <Field
                            name="maybeOptionSpot"
                            component={CheckboxField}
                            label="Maybes takes up a spot"
                          />
                        </Col>
                      </Row>
                    )}
                  </>
                )}
              </CardBody>
            </Card>
            <Row className="my-2">
              <Col className="d-flex justify-content-center">
                <SaveButton
                  type="button"
                  content="Save"
                  onClick={props.saveHandler}
                />
              </Col>
            </Row>
          </Col>
          <Col xl={4} className="mt-4 custom-features-preview">
            <Preview
              bgImage={props.design?.bg_image_url}
              title={props.formValues?.name}
              startDate={props.formValues?.startDate}
              startHour={props.formValues?.startHour}
              startMinute={props.formValues?.startMinute}
              startTimeType={props.formValues?.startTimeType}
              endDate={props.formValues?.endDate}
              endHour={props.formValues?.endHour}
              endMinute={props.formValues?.endMinute}
              endTimeType={props.formValues?.endTimeType}
              locationName={props.formValues?.locationName}
              address={props.formValues?.address}
              meetingLink={props.formValues?.meetingLink}
              extraDetails={props.formValues?.extraDetails}
              rsvpOption={props.formValues?.rsvpOption}
            />
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

const selector = formValueSelector(FORM_NAMES.EVENT_INFO)

const mapStateToProps = state => ({
  rsvpOption: selector(state, "event_info_form.rsvpOption"),
  maybeOption: selector(state, "event_info_form.maybeOption"),
  startDate: selector(state, "event_info_form.startDate"),
  eventInfo: state.EventInfo.eventInfo,
  vendorId: state.Login.vendorId,
  selectedEvent: state.experiences.selectedEvent,
  formValues: selector(state, "event_info_form"),
  rsvpBookedSpots: state.EventInfo.rsvpBookedSpots,
})

const mapDispatchToProps = dispatch => ({
  getEventInfo: value => dispatch(getEventInfo(value)),
  resetEventInfo: () => dispatch(resetEventInfo()),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.EVENT_INFO, { event_info_form: values })),
  changeField: (field, value) =>
    dispatch(change(FORM_NAMES.EVENT_INFO, field, value)),
  addEventInfo: values => dispatch(addEventInfo(values)),
  updateEventInfo: values => dispatch(updateEventInfo(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(EventInfoTab)
